class Customer.StaleNoticeView extends Backbone.View
  template: JST['backbone/templates/customer/stale_notice']

  #Doesn't work every time this view is shown, I guess that the "bind" is lose
  #events:
  #  'click .stale-refresh' : 'onRefresh'

  initialize: (@options = {}) ->
    @refreshNeeded = false

  render: ->
    @$el.html(@template())    
    @$el.find('.stale-refresh').on('click', @onRefresh)
    @$el.find('.stale-close').on('click', @onClose)
    @$el.css('text-align', 'center')
    @$el.hide()
    @

  onClose: =>
    @$el.hide()

  onRefresh: =>
    @trigger('refresh:tab')
    @hideRefreshNeeded()    

  showRefreshNeeded: ->
    @$el.show()
    @refreshNeeded = true

  hideRefreshNeeded: ->
    @$el.hide()
    @refreshNeeded = false

  isRefreshNeeded: ->
    return @refreshNeeded

  setRefreshNeeded: (value) ->
    @refreshNeeded = value
